"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'googleDrive.picker.title': 'Select Google Drive File',
    'googleDrive.picker.selectFile': 'Select File from Google Drive',
    'googleDrive.picker.selectFiles': 'Select Files from Google Drive',
    'googleDrive.picker.loading': 'Loading Google Drive API...',
    'googleDrive.picker.initializing': 'Initializing file picker...',
    'googleDrive.picker.notAuthenticated': 'Google Drive not connected',
    'googleDrive.picker.statusError': 'Failed to check Google Drive status',
    'googleDrive.picker.filesLoadError': 'Failed to load files',
    'googleDrive.picker.checkingAuth': 'Checking authentication...',
    'googleDrive.picker.authRequired': 'Please connect your Google Drive account first',
    'googleDrive.picker.connectAccount': 'Connect Google Drive',
    'googleDrive.picker.loadingFiles': 'Loading your Google Drive files...',
    'googleDrive.picker.noFiles': 'No files found',
    'googleDrive.picker.noFilesDesc': 'Your Google Drive appears to be empty',
    'googleDrive.picker.refresh': 'Refresh',
    'googleDrive.picker.searchPlaceholder': 'Search files...',
    'googleDrive.picker.filesFound': 'files found',
    'googleDrive.picker.initError': 'Failed to initialize Google Drive picker',
    'googleDrive.picker.loadingError': 'Failed to load Google Drive APIs',
    'googleDrive.picker.noAccessToken': 'No access token available',
    'googleDrive.picker.error': 'Google Drive picker error',
    'googleDrive.picker.fileSelected': 'File selected',
    'googleDrive.picker.filesSelected': 'files selected',
    'googleDrive.picker.authError': 'Google authentication failed',
    'googleDrive.picker.configError': 'Google configuration error',
    'googleDrive.picker.connectFirst': 'Please connect Google Drive in settings first',
    'googleDrive.picker.tokenExpired': 'Google Drive access has expired. Please reconnect your Google Drive account in settings.',
    'googleDrive.picker.refreshFailed': 'Failed to refresh Google Drive access. Please reconnect your account in settings.',
};
